<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="search-outline"></nb-icon>
        <div class="ml-2" i18n>Viewing Robot: {{ robot.id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <strong class="text-uppercase" i18n>Robot Details</strong>
    <dl class="row">
      <dt class="col-4" i18n>ID</dt>
      <dd class="col-8">{{ robot.id }}</dd>
    </dl>
    <dl class="row">
      <dt class="col-4" i18n>Name</dt>
      <dd class="col-8">{{ robot.name }}</dd>
    </dl>
    <dl class="row">
      <dt class="col-4" i18n>Family</dt>
      <dd class="col-8">{{ robot.family }}</dd>
    </dl>
    <dl class="row">
      <dt class="col-4" i18n>SKU</dt>
      <dd class="col-8">{{ robot.sku }}</dd>
    </dl>
    <dl class="row">
      <dt class="col-4" i18n>Serial number</dt>
      <dd class="col-8" *ngIf="robot.serial_number">
        {{ robot.serial_number }}
      </dd>
      <dd class="col-8" *ngIf="!robot.serial_number">-</dd>
    </dl>
    <dl class="row">
      <dt class="col-4" i18n>Registration Date</dt>
      <dd class="col-8">{{ robot.registration_date | format : 'dttm' }}</dd>
    </dl>
    <dl class="row">
      <dt class="col-4" i18n>Timezone</dt>
      <dd class="col-8">{{ robot.timezone }}</dd>
    </dl>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton status="info" (click)="close()" i18n>Close</button>
    </div>
  </nb-card-footer>
</nb-card>
